
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'ButtonCircle',
})
export default class ButtonCircle extends Vue {}
